import { Box, Chip, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { TestType } from "../types/guestTestTemplate";


const GTTestList = ({
    answers, setTryingNo, data,
}:{
    answers: (number|null)[], setTryingNo: (tryingNo: number) => void, data: TestType[]
}) => {
    return (
        <>
            認知特性テスト
            <List sx={{ width: '100%', bgcolor: 'background.paper', overflow: 'auto', maxHeight: window.innerHeight * 0.7,}}>
                {answers?.map((a,i) => (<ListItem disablePadding sx={{backgroundColor: '#f8f8f8'}}>
                    <ListItemButton role={undefined} onClick={() => {setTryingNo(i)}} dense>
                        <ListItemText
                            primary={
                                <Box>
                                    ☆問題{i+1}　{a === null && <Chip label='未回答'/>}
                                </Box>
                            }
                            secondary={
                                `　${data[i].question?.length > 20 
                                    ? data[i].question.substring(0,19) + '...'
                                    : data[i].question}`
                            }
                        />
                    </ListItemButton>
                </ListItem>))}
            </List>
        </>
    )
}

export default GTTestList;